/* lv-cart.js — theme-native replica of the UpCart drawer for Maison Lunavive (Oct 2026).
 *
 * Renders from /cart.js after every change. The shipping protection is an ordinary cart line
 * (product type "Shipping Protection", tag cart-addon) that is hidden from the item list and
 * shown as a switch in the footer instead. It is on by default, added once per page view, and a
 * customer who switches it off stays opted out for the session.
 *
 * Tier discounts come from Shopify (automatic discounts on a collection that leaves the
 * protection out); this file only mirrors them. That is why every count here subtracts the
 * protection line: the bar must say what the checkout will do.
 */
(function () {
  var root = document.querySelector('[data-lvc]');
  var backdrop = document.querySelector('[data-lvc-backdrop]');
  var cfgEl = document.querySelector('[data-lvc-config]');
  if (!root || !cfgEl) return;

  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || CFG.root || '/';
  // Our own requests bypass the add-to-cart listener below (adding the protection must not reopen the drawer).
  var rawFetch = window.fetch.bind(window);

  // Broadcast redirects to /cart after an add when cartType is "page", and opens its own drawer
  // when it is "drawer". Any other value makes it add via fetch and do neither, so our drawer
  // takes over without touching the theme's code.
  if (window.theme && theme.settings) theme.settings.cartType = 'lvc';

  var PROT = CFG.protection || {};
  var protVariantId = PROT.variantId ? parseInt(PROT.variantId, 10) : 0;
  var PROT_OPTOUT = 'lvcProtectionOptOut';
  var protBusy = false;
  var protAutoAdded = false; // set synchronously before the fetch: two refreshes must not add it twice

  var TIERS = String(CFG.tiers || '').split(',').map(function (chunk) {
    var p = chunk.split(':').map(function (s) { return s.trim(); });
    var min = parseInt(p[0], 10), pct = parseFloat(p[1]);
    return (min > 0 && pct > 0) ? { min: min, pct: pct } : null;
  }).filter(Boolean).sort(function (a, b) { return a.min - b.min; });

  var MSG_BEFORE = CFG.msgBefore || 'Only <strong>{count}</strong> more {items} to get {pct}% off';
  var MSG_DONE = CFG.msgDone || 'Nice! Your <strong>{pct}% discount</strong> has been applied';

  var ICON_TAG = '<svg aria-hidden="true" focusable="false" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.575 4.649a3.75 3.75 0 0 1 2.7-1.149h1.975a3.25 3.25 0 0 1 3.25 3.25v2.187a3.25 3.25 0 0 1-.996 2.34l-4.747 4.572a2.5 2.5 0 0 1-3.502-.033l-2.898-2.898a2.75 2.75 0 0 1-.036-3.852l4.254-4.417Zm4.425 3.351a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path></svg>';
  var ICON_TRASH = '<svg aria-hidden="true" focusable="false" viewBox="0 0 20 20"><path d="M11.5 8.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0v-4.25a.75.75 0 0 1 .75-.75Z"></path><path d="M9.25 9a.75.75 0 0 0-1.5 0v4.25a.75.75 0 0 0 1.5 0v-4.25Z"></path><path fill-rule="evenodd" d="M7.25 5.25a2.75 2.75 0 0 1 5.5 0h3a.75.75 0 0 1 0 1.5h-.75v5.45c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327h-.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-5.45h-.75a.75.75 0 0 1 0-1.5h3Zm1.5 0a1.25 1.25 0 1 1 2.5 0h-2.5Zm-2.25 1.5h7v5.45c0 .865-.001 1.423-.036 1.848-.033.408-.09.559-.128.633a1.5 1.5 0 0 1-.655.655c-.074.038-.225.095-.633.128-.425.035-.983.036-1.848.036h-.4c-.865 0-1.423-.001-1.848-.036-.408-.033-.559-.09-.633-.128a1.5 1.5 0 0 1-.656-.655c-.037-.074-.094-.225-.127-.633-.035-.425-.036-.983-.036-1.848v-5.45Z"></path></svg>';
  var ICON_MINUS = '<svg aria-hidden="true" focusable="false" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M5 10c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75Z"></path></svg>';
  var ICON_PLUS = '<svg aria-hidden="true" focusable="false" viewBox="0 0 20 20"><path d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"></path></svg>';

  function el(sel) { return root.querySelector(sel); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Money in the CART's currency. The shop format is GBP ("£{{amount}}"), but the US market pays
  // in USD; formatting with the shop format would print dollar amounts with a pound sign.
  var cartCurrency = CFG.currency || 'GBP';
  function money(cents) {
    var cur = cartCurrency || 'GBP';
    try {
      return new Intl.NumberFormat(cur === 'GBP' ? 'en-GB' : 'en-US', { style: 'currency', currency: cur }).format((cents || 0) / 100);
    } catch (e) {
      return (cur === 'GBP' ? '£' : cur + ' ') + ((cents || 0) / 100).toFixed(2);
    }
  }

  var productCache = {};
  function loadProducts(cart) {
    var missing = [];
    cart.items.forEach(function (i) {
      if (i.variant_id !== protVariantId && !productCache[i.handle] && missing.indexOf(i.handle) < 0) missing.push(i.handle);
    });
    return Promise.all(missing.map(function (h) {
      return rawFetch(ROOT + 'products/' + h + '.js').then(function (r) { return r.json(); })
        .then(function (p) { productCache[h] = p || {}; })
        .catch(function () { productCache[h] = {}; });
    }));
  }
  function compareAtFor(item) {
    var p = productCache[item.handle] || {};
    var v = (p.variants || []).filter(function (x) { return x.id === item.variant_id; })[0];
    return v && v.compare_at_price ? v.compare_at_price : 0;
  }

  function realItems(cart) { return cart.items.filter(function (i) { return i.variant_id !== protVariantId; }); }
  function realCount(cart) { return realItems(cart).reduce(function (s, i) { return s + i.quantity; }, 0); }

  // ── Open / close ──────────────────────────────────────────────────
  var lastFocus = null;
  function open() {
    if (root.classList.contains('is-open')) { refresh(); return; }
    lastFocus = document.activeElement;
    // Fixed elements: moving them to the end of <body> keeps us above apps that inject later.
    document.body.appendChild(backdrop); document.body.appendChild(root);
    backdrop.hidden = false; root.hidden = false;
    document.body.classList.add('lvc-open');
    refresh();
    // Force a reflow so the slide-in transition starts from the hidden state. Not
    // requestAnimationFrame: that pauses in background tabs and would leave the drawer shut.
    void root.offsetWidth;
    backdrop.classList.add('is-open'); root.classList.add('is-open');
    var c = el('[data-lvc-close]'); if (c) c.focus({ preventScroll: true });
  }
  function close() {
    root.classList.remove('is-open'); backdrop.classList.remove('is-open');
    document.body.classList.remove('lvc-open');
    setTimeout(function () {
      if (!root.classList.contains('is-open')) { root.hidden = true; backdrop.hidden = true; }
    }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  // ── Render ────────────────────────────────────────────────────────
  function renderItems(cart) {
    var items = realItems(cart);
    var list = el('[data-lvc-items]');
    list.innerHTML = cart.items.map(function (item, n) {
      if (item.variant_id === protVariantId) return '';
      var line = n + 1;
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=176' : '';
      var opts = (item.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(', ');
      var compare = compareAtFor(item) * item.quantity;
      var price = item.original_line_price;
      var savings = compare > price ? compare - price : 0;
      return '<li class="lvc-item"><div class="lvc-tile"><div class="lvc-tile__content">' +
        '<a class="lvc-tile__image" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="88" height="88" decoding="async">' : '') + '</a>' +
        '<div class="lvc-tile__info">' +
          '<div class="lvc-tile__header"><h4 class="lvc-tile__title"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></h4>' +
          '<button type="button" class="lvc-tile__remove" data-lvc-remove data-line="' + line + '" aria-label="Remove ' + esc(item.product_title) + '">' + ICON_TRASH + '</button></div>' +
          (opts ? '<div class="lvc-tile__variant"><span>' + opts + '</span></div>' : '') +
          '<div class="lvc-tile__pricing"><span class="lvc-tile__price-group">' +
            (savings ? '<span class="visually-hidden">Original price</span><span class="lvc-tile__compare">' + esc(money(compare)) + '</span>' : '') +
            '<span class="visually-hidden">Sale price</span><span class="lvc-tile__price">' + esc(money(price)) + '</span></span>' +
            (savings ? '<span class="lvc-tile__savings">(Save ' + esc(money(savings)) + ')</span>' : '') +
          '</div>' +
          '<div class="lvc-tile__controls"><div class="lvc-qty">' +
            '<button type="button" data-lvc-qty="-1" data-line="' + line + '" aria-label="Decrease quantity">' + ICON_MINUS + '</button>' +
            '<input type="number" min="0" inputmode="numeric" value="' + item.quantity + '" data-lvc-qty-input data-line="' + line + '" aria-label="Quantity">' +
            '<button type="button" data-lvc-qty="1" data-line="' + line + '" aria-label="Increase quantity">' + ICON_PLUS + '</button>' +
          '</div></div>' +
        '</div></div></div></li>';
    }).join('');
    el('[data-lvc-empty]').hidden = items.length > 0;
    el('[data-lvc-footer]').hidden = items.length === 0;
    var ann = el('[data-lvc-announcement]'); if (ann) ann.hidden = items.length === 0;
  }

  function renderRewards(cart) {
    var box = el('[data-lvc-rewards]');
    var n = realCount(cart);
    if (!TIERS.length || n === 0) { box.hidden = true; return; }
    box.hidden = false;
    var next = TIERS.filter(function (t) { return n < t.min; })[0];
    var msg;
    if (next) {
      var rem = next.min - n;
      msg = MSG_BEFORE.replace('{count}', rem).replace('{items}', rem === 1 ? 'item' : 'items').replace('{pct}', next.pct);
    } else {
      msg = MSG_DONE.replace('{pct}', TIERS[TIERS.length - 1].pct);
    }
    el('[data-lvc-rewards-message]').innerHTML = '<p>' + msg + '</p>';
    var prev = 0;
    el('[data-lvc-rewards-bar]').innerHTML = TIERS.map(function (t) {
      var span = t.min - prev;
      var frac = Math.max(0, Math.min(1, (n - prev) / span));
      prev = t.min;
      return '<div class="lvc-seg"><div class="lvc-seg__fill" style="width:' + (frac * 100) + '%"></div>' +
        '<div class="lvc-seg__icon' + (n >= t.min ? ' is-reached' : '') + '">' + ICON_TAG + '</div>' +
        '<div class="lvc-seg__label">' + t.pct + '% off</div></div>';
    }).join('');
  }

  function renderTotals(cart) {
    var count = realCount(cart);
    el('[data-lvc-count]').textContent = count;
    var saved = cart.total_discount || 0;
    el('[data-lvc-summary]').hidden = !saved;
    el('[data-lvc-saved]').textContent = '- ' + money(saved);
    el('[data-lvc-total]').textContent = money(cart.total_price);
    el('[data-lvc-checkout]').disabled = count === 0;
    // Broadcast's header badge listens to this event; give it the real product count.
    document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cartCount: count, cart: cart } }));
  }

  // ── Shipping protection ───────────────────────────────────────────
  function protLine(cart) {
    var found = null;
    cart.items.forEach(function (i, n) { if (i.variant_id === protVariantId) found = { line: n + 1, item: i }; });
    return found;
  }
  function optedOut() { try { return sessionStorage.getItem(PROT_OPTOUT) === '1'; } catch (e) { return false; } }
  function setOptOut(v) { try { v ? sessionStorage.setItem(PROT_OPTOUT, '1') : sessionStorage.removeItem(PROT_OPTOUT); } catch (e) {} }

  function post(path, body) {
    return rawFetch(ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }

  // Returns true when it changed the cart (the caller then renders again).
  function syncProtection(cart) {
    if (!protVariantId) return false;
    var found = protLine(cart);
    var hasReal = realItems(cart).length > 0;
    // Nothing left to protect: take the protection out as well.
    if (!hasReal && found && !protBusy) {
      protBusy = true;
      return post('cart/change.js', { line: found.line, quantity: 0 }).then(function () { protBusy = false; return true; })
        .catch(function () { protBusy = false; return false; });
    }
    // Never more than one.
    if (found && found.item.quantity > 1 && !protBusy) {
      protBusy = true;
      return post('cart/change.js', { line: found.line, quantity: 1 }).then(function () { protBusy = false; return true; })
        .catch(function () { protBusy = false; return false; });
    }
    if (hasReal && !found && PROT.defaultOn && !optedOut() && !protBusy && !protAutoAdded) {
      protAutoAdded = true;
      protBusy = true;
      return post('cart/add.js', { items: [{ id: protVariantId, quantity: 1 }] }).then(function () { protBusy = false; return true; })
        .catch(function () { protBusy = false; return false; });
    }
    return false;
  }

  function renderProtection(cart) {
    var wrap = el('[data-lvc-protection]');
    if (!wrap || !protVariantId) return;
    wrap.hidden = realItems(cart).length === 0;
    var found = protLine(cart);
    var price = found ? found.item.final_price : (PROT.price || 0);
    el('[data-lvc-protection-price]').textContent = price ? money(price) : '';
    var sw = el('[data-lvc-protection-toggle]');
    sw.setAttribute('aria-checked', found ? 'true' : 'false');
    sw.disabled = protBusy;
  }

  function toggleProtection() {
    if (!protVariantId || protBusy) return;
    protBusy = true;
    el('[data-lvc-protection-toggle]').disabled = true;
    rawFetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var found = protLine(cart);
      if (found) { setOptOut(true); protAutoAdded = true; return post('cart/change.js', { line: found.line, quantity: 0 }); }
      setOptOut(false);
      return post('cart/add.js', { items: [{ id: protVariantId, quantity: 1 }] });
    }).then(function () { protBusy = false; return refresh(); })
      .catch(function () { protBusy = false; return refresh(); });
  }

  // ── Cart traffic ──────────────────────────────────────────────────
  var refreshing = null;
  function refresh() {
    if (refreshing) return refreshing;
    refreshing = rawFetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.currency) cartCurrency = cart.currency;
        var changed = syncProtection(cart);
        return Promise.resolve(changed).then(function (did) {
          return did ? rawFetch(ROOT + 'cart.js').then(function (r) { return r.json(); }) : cart;
        });
      })
      .then(function (cart) { return loadProducts(cart).then(function () { return cart; }); })
      .then(function (cart) {
        renderItems(cart); renderRewards(cart); renderProtection(cart); renderTotals(cart);
        return cart;
      })
      .finally(function () { refreshing = null; });
    return refreshing;
  }

  function setBusy(on) { var l = el('[data-lvc-items]'); if (l) l.classList.toggle('is-busy', on); }
  function change(line, quantity) {
    setBusy(true);
    return post('cart/change.js', { line: line, quantity: Math.max(0, quantity) })
      .then(function () { return refresh(); }, function () { return refresh(); })
      .then(function () { setBusy(false); });
  }

  // ── Events ────────────────────────────────────────────────────────
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lvc-close],[data-lvc-remove],[data-lvc-qty],[data-lvc-protection-toggle]');
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-lvc-close')) return close();
    if (t.hasAttribute('data-lvc-protection-toggle')) return toggleProtection();
    var line = parseInt(t.getAttribute('data-line'), 10);
    if (t.hasAttribute('data-lvc-remove')) return change(line, 0);
    var input = t.parentNode.querySelector('[data-lvc-qty-input]');
    var current = parseInt(input && input.value, 10) || 0;
    return change(line, current + parseInt(t.getAttribute('data-lvc-qty'), 10));
  });
  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-lvc-qty-input]');
    if (!input) return;
    var q = parseInt(input.value, 10);
    change(parseInt(input.getAttribute('data-line'), 10), isNaN(q) ? 1 : q);
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    // Keep focus inside the open dialog.
    var f = Array.prototype.filter.call(root.querySelectorAll('a[href],button:not([disabled]),input'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  backdrop.addEventListener('click', close);

  // Every link to /cart opens the drawer instead of the cart page (capture: before the theme).
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-cart-toggle], [data-lvc-open]');
    if (!a || root.contains(a)) return;
    e.preventDefault(); e.stopPropagation();
    open();
  }, true);

  // Open after anything is added (Broadcast product form, quick add, upsells); refresh when the
  // cart changes elsewhere while the drawer is open.
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var res = origFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      res.then(function (r) { if (r.ok) open(); }).catch(function () {});
    }
    return res;
  };

  // Broadcast keeps its own <cart-drawer>. After every add it rebuilds that drawer in the
  // background and fires "theme:product:added", on which the drawer opens itself BEHIND ours;
  // once ours closed, the stale theme cart was left on screen. Detach its open triggers (the
  // bound handlers live on the instance) and send every route to our drawer instead. The event
  // itself keeps flowing, because the quick-add modal closes on it.
  function tameThemeDrawer() {
    var td = document.querySelector('cart-drawer');
    if (!td || td.__lvcTamed) return;
    td.__lvcTamed = true;
    try { if (td.openCartDrawerOnProductAdded) document.removeEventListener('theme:product:added', td.openCartDrawerOnProductAdded); } catch (e) {}
    try { if (td.toggleCartDrawer) document.removeEventListener('theme:cart:toggle', td.toggleCartDrawer); } catch (e) {}
    try { if (td.openCartDrawer) td.removeEventListener('theme:cart-drawer:show', td.openCartDrawer); } catch (e) {}
    td.openCartDrawer = function () { open(); };
    td.toggleCartDrawer = function () { open(); };
    td.openCartDrawerOnProductAdded = function () {};
    if (td.classList.contains('is-open') && td.closeCartDrawer) { try { td.closeCartDrawer(); } catch (e) {} }
  }
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(tameThemeDrawer);
  tameThemeDrawer();
  // Belt and braces: anything that still asks the theme to toggle its cart gets ours.
  document.addEventListener('theme:cart:toggle', function (e) { e.stopImmediatePropagation(); open(); }, true);
  document.addEventListener('theme:cart-drawer:show', function (e) { e.stopImmediatePropagation(); open(); }, true);
  // The theme's rebuild also rewrites the header badge with the protection counted; correct it.
  document.addEventListener('theme:product:added', function () { setTimeout(refresh, 50); });

  window.lvCart = { open: open, close: close, refresh: refresh };

  // First paint: correct the header badge (it counts the protection line server-side).
  refresh();
})();
